export const API_KEY = process.env.REACT_APP_TMDB_KEY

export const BASE_URL = 'https://api.themoviedb.org/3'